// src/pages/legal/ProviderAgreementPage.tsx
import React from 'react';
import LegalDocumentPage from './LegalDocumentPage';

const ProviderAgreementPage: React.FC = () => (
  <LegalDocumentPage slug="provider-agreement" fallbackTitle="Service Provider Agreement" />
);

export default ProviderAgreementPage;
